import { AnyAction, createSlice } from '@reduxjs/toolkit'
import { ResponseType } from '../interfaces/response'
import { contactUs } from '../data-access/apis/common/contact';
// import { jwtDecode } from 'jwt-decode'

const contactLifeCycles = createSlice({
    name: 'contact',
    initialState: {
        status: ResponseType.Pending,
        statusCode: null,
        user: null,
        token: null,
        loading: false,
        errors: null,
        message: null,
        usernameAvailable: null,  // add new field to track username availability
    },
    reducers: {
        resetContact: (state) => {
            state.status = ResponseType.Pending;
            state.statusCode = null;
            state.user = null;
            state.token = null
            state.loading = false;
            state.errors = null;
            state.message = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(contactUs.pending, (state) => {
                state.loading = true
            })
            .addCase(contactUs.fulfilled, (state, action: AnyAction) => {
                state.loading = false
                state.message = action.payload.message
                state.statusCode = action.payload.status
                state.status = ResponseType.Success
            })
            .addCase(contactUs.rejected, (state, action: AnyAction) => {
                state.loading = false
                state.statusCode = action.payload.status
                state.message = action.payload?.data?.message
                state.errors = action.error?.message
                state.status = ResponseType.Failed
            })
    }
})

export const { resetContact } = contactLifeCycles.actions;
export default contactLifeCycles.reducer
